// extracted by mini-css-extract-plugin
module.exports = {"titleBlock":"NotificationsBlock_titleBlock__R2WO1"};